import { Injectable } from '@angular/core';
import { CustomAjax } from '../AjaxHelper';

@Injectable({
  providedIn: 'root'
})
export class LookupsService {

  constructor(private ajax: CustomAjax) { }

  public ProvinceGet(fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/Lookups/ProvinceGet", ``,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public GenderGet(fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/Lookups/GenderGet", ``,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public TitleGet(fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/Lookups/TitleGet", ``,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }
  public TimesGet(fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/Lookups/TimesGet", ``,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }
  public LeaveTypesGet(fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/Lookups/LeaveTypesGet", ``,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }
  public DurationsGet(fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/Lookups/DurationsGet", ``,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }
  public AdministrationTypesGet(fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/Lookups/AdministrationTypesGet", ``,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public UserTypeGet(fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/Lookups/UserTypeGet", ``,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public InvoiceTypeGet(fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/Lookups/InvoiceTypeGet", ``,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }
  
  public MemberStatusGet(fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/Lookups/MemberStatusGet", ``,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }
  
  public MemberGroupGet(fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/Lookups/MemberGroupGet", ``,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }
}
